// Third-party libs
// require('../../../assets/lib/jquery/jquery-3.7.1.min.js');
require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/lib/angularJS-NES/angular.min.js');
require('../../../assets/lib/angularJS-NES/angular-route.min.js');
require('../../../assets/lib/angularJS-NES/angular-sanitize.min.js');
require('../../../assets/lib/angularJS-NES/angular-animate.min.js');
require('../../../assets/lib/angular/angular-ui.js');
require('../../../assets/lib/json2.js');
require('../../../assets/lib/log4javascript/log4javascript.js');

require('../../../assets/scripts/candidates/jv.Candidates.List.app.js');
// Common
require('../../../assets/scripts/common/directives/jv.Tinymce.webpack.js');
require('../../../assets/scripts/common/jv.Filters.webpack.js');
require('../../../assets/scripts/common/jv.TextUtil.js');
require('../../../assets/scripts/common/jv.log4javascript.webpack.js');
require('../../../assets/scripts/common/totango/jv.totango.js');
require('../../../assets/scripts/common/angajaxservice.js');

// Jhire
require('../../../assets/scripts/jhire/jv.directives.webpack.js');
require('../../../assets/scripts/jhire/modules/jv.webpack.js');
require('../../../assets/scripts/jhire/services/jv.Hire.Url.Service.js');
require('../../../assets/scripts/jhire/services/jv.Hire.Broadcast.Service.js');
require('../../../assets/scripts/jhire/services/jv.services.js');
require('../../../assets/scripts/jhire/services/jv.App.js');
require('../../../assets/scripts/jhire/services/jv.AppModel.js');
